import { InjectionToken } from '@angular/core';

export const VM_GLOBAL_CONFIG = new InjectionToken<VmGlobalConfig>('PL config');

export interface VmGlobalConfig {
  assetsPath?: string;
  components?: string[];
  deployUrl?: string;
}
